<template>
    <div class="select_dialog_embed">
      <div class="car_embed_msg">
        <div class="select_dialog_embed_box">
          <!--弹出框头部-->
          <div class="select_dialog_embed_box_top">
            <p>{{title}}</p>
          </div>

          <!--弹出框信息-->
          <!--删除单个/多个购物车-->
          <div v-if="showType === 'delCarGoods'" class="select_dialog_embed_box_content mt40 mb40 text_center fs16">
            <p>是否删除所选商品？</p>
          </div>

          <!--清空购物车-->
          <div v-if="showType === 'clearCarGoods'" class="select_dialog_embed_box_content mt40 mb40 text_center fs16">
            <p>是否清空购物车？</p>
          </div>

          <!--订单结算确认-->
          <div v-if="showType === 'settlement'" class="select_dialog_embed_box_content mt40 mb40 text_center fs16">
            <p>该收货人72小时内有下过订单，{{carOrderMsg}},确认继续提交？</p>
          </div>

          <!--弹出框底部-->
          <div class="select_dialog_embed_box_bottom">
            <button class="btn_normal" @click="submitBtn()">确定</button>
            <button class="btn_cancel" @click="cancelBtn()">取消</button>
          </div>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :is-suc="isSuc"
                  :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
    </div>
</template>

<script type="es6">
  import { mapMutations } from 'vuex';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

    export default {
        name: 'car-embed-msg',
      /**
       *  title：  头部名
       *  showType:
       *  carOrderMsg: 订单信息
       * */
      props: ['title', 'showType', 'carOrderMsg'],
      components: {MsgDialog, LoadingDialog},
      computed: {
        goodsList() {
          return this.$store.state.carGoodsList;
        }
      },
      data() {
        return {
          isLoading: false, // 是否显示加载框
          loadingType: 'NOP', // 加载页面类型
          isMsg: false, // 信息框显示
          isSuc: false, // 是否成功
          txtMsg: '信息框内容' // 信息框内容
        }
      },
      methods: {
        ...mapMutations(
          ['deleteCarGoods', 'updateCarGoods', 'clearCarGoods']
        ),

        // 检索id位置下标
        findPosition(Id) {
          return this.goodsList.findIndex(item => {
            return item.Id === Id;
          });
        },

        // 删除购物车里的货品
        delShoppingCartById(type, id) {
          const i = this.findPosition(id);
          let params = [];
          if (type) {
            params = [];
          } else {
            params = [id];
          }
          this.$axios.post(this.Global.delShoppingCartById(type), params).then((res) => {
            if (!res.data.errorMsg.length) {
              if (this.showType === 'delCarGoods') {
                this.deleteCarGoods(i);
              } else {
                this.clearCarGoods();
              }
              this.cancelBtn(this.showType);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 提交按钮
        submitBtn() {
          // console.log(this.carOrderMsg);
          if (this.showType === 'delCarGoods') {
            this.delShoppingCartById(false, this.carOrderMsg.Id);
          } else if (this.showType === 'clearCarGoods') {
            this.delShoppingCartById(true, 0);
          } else if (this.showType === 'settlement') {
            this.cancelBtn(true);
          }
        },

        // 取消按钮
        cancelBtn(type) {
          this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
        },

        // 接收提示框传送的数据
        closeMsgDialog(e) {
          this.isMsg = e;
        }
      },
      created() {
        console.log(this.carOrderMsg);
        console.log(this.showType);
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .car_embed_msg {
    background-color: #fff;
    max-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/car-embed-msg.vue